<template>
  <div id="Error404" class="p-30 container">
    <h1>404</h1>
  </div>
</template>
<script>
export default {
  name: 'Error404',
}
</script>
<style>
</style>
